import { c as _c } from "react/compiler-runtime";
import { Alert, Box, Center, Spinner, Text } from '@chakra-ui/react';
import { heldTermByProductId } from '@src/components/sco/UpgradeForm';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { PaywallProductGrid } from '../PaywallProductGrid';
import { ADVISOR_TEAM_PRODUCT_ID, STARTUPS_PRO_PRODUCT_ID, type PaywallIntentId } from '../intent';
import { conversionCheckoutHref, readConversionCheckoutParams } from './checkoutParams';
import { useConversionProducts } from './useConversionProducts';
const LADDER = [STARTUPS_PRO_PRODUCT_ID, ADVISOR_TEAM_PRODUCT_ID];
export type ConversionPlansProps = {
  /** Intent when the URL does not carry one (e.g. `investor-matching-plans` → a fundraising intent). */
  defaultIntent?: PaywallIntentId;
};

/**
 * Plan chooser (`?prompt=plans`): the membership ladder from the live catalog. Choosing a plan
 * swaps the dialog to the Conversion checkout for that product, keeping the page underneath.
 */
export const ConversionPlans = t0 => {
  const $ = _c(39);
  const {
    defaultIntent: t1
  } = t0;
  const defaultIntent = t1 === undefined ? "default" : t1;
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  let t2;
  if ($[0] !== params) {
    t2 = readConversionCheckoutParams(params);
    $[0] = params;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const request = t2;
  const intent = request.intent || defaultIntent;
  const {
    currentUser
  } = useCurrentUser();
  const termId = request.termId || "month";
  let t3;
  if ($[2] !== request.couponCode || $[3] !== termId) {
    t3 = {
      termId,
      couponCode: request.couponCode
    };
    $[2] = request.couponCode;
    $[3] = termId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    products,
    loading,
    error
  } = useConversionProducts(LADDER, t3);
  currentUser?.subscriptions;
  let t4;
  if ($[5] !== currentUser?.subscriptions) {
    t4 = (currentUser?.subscriptions || []).filter(_temp).map(_temp2).filter(_temp3);
    $[5] = currentUser?.subscriptions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const activeProductIds = t4;
  let t5;
  if ($[7] !== activeProductIds) {
    t5 = activeProductIds.includes(ADVISOR_TEAM_PRODUCT_ID);
    $[7] = activeProductIds;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onTeam = t5;
  let t6;
  if ($[9] !== activeProductIds || $[10] !== onTeam) {
    t6 = onTeam ? [ADVISOR_TEAM_PRODUCT_ID] : activeProductIds;
    $[9] = activeProductIds;
    $[10] = onTeam;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const currentProductIds = t6;
  let t7;
  if ($[12] !== currentProductIds || $[13] !== currentUser || $[14] !== termId) {
    t7 = heldTermByProductId(currentUser, currentProductIds, termId);
    $[12] = currentProductIds;
    $[13] = currentUser;
    $[14] = termId;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const currentTermByProductId = t7;
  let t8;
  if ($[16] !== activeProductIds || $[17] !== onTeam) {
    t8 = onTeam ? [] : LADDER.filter(productId => !activeProductIds.includes(productId));
    $[16] = activeProductIds;
    $[17] = onTeam;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const eligibleProductIds = t8;
  if (loading && products.length === 0) {
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Center minH="20rem" w={{
        base: "full",
        md: "56rem"
      }}><Spinner aria-label="Loading plans" /></Center>;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    return t9;
  }
  if (error || products.length === 0) {
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Box maxW="full" p={8} w="28rem"><Alert.Root status="error"><Alert.Indicator /><Text>Plans aren’t available right now.</Text></Alert.Root></Box>;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  let t10;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      base: 5,
      md: 8
    };
    t10 = {
      base: "full",
      md: "56rem"
    };
    $[21] = t10;
    $[22] = t9;
  } else {
    t10 = $[21];
    t9 = $[22];
  }
  const t11 = request.tokens || undefined;
  let t12;
  if ($[23] !== intent || $[24] !== params || $[25] !== pathname || $[26] !== request.couponCode || $[27] !== request.termId || $[28] !== request.tokens || $[29] !== router) {
    t12 = product => {
      if (!product.productId) {
        return;
      }
      router.push(conversionCheckoutHref(pathname || "/", params?.toString(), {
        productId: product.productId,
        intent,
        tokens: request.tokens,
        termId: request.termId,
        couponCode: request.couponCode
      }), undefined, {
        scroll: false,
        shallow: true
      });
    };
    $[23] = intent;
    $[24] = params;
    $[25] = pathname;
    $[26] = request.couponCode;
    $[27] = request.termId;
    $[28] = request.tokens;
    $[29] = router;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== currentProductIds || $[32] !== currentTermByProductId || $[33] !== eligibleProductIds || $[34] !== intent || $[35] !== products || $[36] !== t11 || $[37] !== t12) {
    t13 = <Box maxW="full" p={t9} w={t10}><PaywallProductGrid assurance="Cancel anytime" currentProductIds={currentProductIds} currentTermByProductId={currentTermByProductId} eligibleProductIds={eligibleProductIds} intent={intent} products={products} showPlanSummary={false} tokens={t11} onContinue={t12} /></Box>;
    $[31] = currentProductIds;
    $[32] = currentTermByProductId;
    $[33] = eligibleProductIds;
    $[34] = intent;
    $[35] = products;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
function _temp(subscription) {
  return subscription?.isActive;
}
function _temp2(subscription_0) {
  return subscription_0?.productId || subscription_0?.product?.productId || "";
}
function _temp3(id) {
  return LADDER.includes(id);
}